import { defineMessages } from 'react-intl';

export default defineMessages({
  gdprNotice: {
    id: 'global_cookies_usage_gdpr_notice',
    defaultMessage:
      'We use cookies to personalize your experience. If that’s okay, just keep browsing.',
  },
  gdprInfo: {
    id: 'global_cookies_usage_gdpr_info',
    defaultMessage: 'More info',
  },
  gdprYes: {
    id: 'global_cookies_usage_gdpr_yes',
    defaultMessage: 'Agree',
  },
  gdprNo: {
    id: 'global_cookies_usage_gdpr_no',
    defaultMessage: 'Disagree',
  },
});



// WEBPACK FOOTER //
// ./app/Gdpr/components/mobile/GdprCookieBanner/messages.js